import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "@/components/Brand";
import { useAuth, homeFor } from "@/context/AuthContext";

const NAV = [
  ["Airport", "/#services"],
  ["Outstation", "/#services"],
  ["Local Packages", "/#packages"],
  ["Fares", "/#fares"],
  ["Partner With Us", "/partner"],
  ["Support", "/contact"],
];

export const SiteHeader = () => {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/90 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 lg:px-8">
        <Link to="/" data-testid="header-home-link"><Logo /></Link>
        <nav className="hidden items-center gap-7 text-sm font-medium text-slate-600 lg:flex">
          {NAV.map(([l, h]) => (
            <a key={l} href={h} className="transition-colors hover:text-[#0A192F]" data-testid={`nav-${l.toLowerCase().replace(/\s/g, "-")}`}>{l}</a>
          ))}
        </nav>
        <div className="hidden items-center gap-3 lg:flex">
          {user ? (
            <>
              <NavLink to={homeFor(user)} className="rounded-full bg-[#0A192F] px-5 py-2 text-sm font-semibold text-white transition-opacity hover:opacity-90" data-testid="header-dashboard-btn">My Dashboard</NavLink>
              <button onClick={logout} className="text-sm text-slate-600 hover:text-[#0A192F]" data-testid="header-logout-btn">Logout</button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-sm font-semibold text-[#0A192F]" data-testid="header-login-btn">Login</Link>
              <Link to="/register?type=driver" className="rounded-full border-2 border-[#0A192F] px-4 py-1.5 text-sm font-bold text-[#0A192F] transition-colors hover:bg-[#0A192F] hover:text-white" data-testid="header-register-driver-btn">Register as a Driver</Link>
              <Link to="/register?type=customer" className="rounded-full bg-[#FFB703] px-4 py-2 text-sm font-bold text-[#0A192F] transition-transform hover:-translate-y-0.5" data-testid="header-register-rider-btn">Register as a Rider</Link>
            </>
          )}
        </div>
        <button className="lg:hidden" onClick={() => setOpen(!open)} aria-label="Menu" data-testid="mobile-menu-toggle">{open ? <X /> : <Menu />}</button>
      </div>
      {open && (
        <div className="border-t bg-white px-5 py-4 lg:hidden" data-testid="mobile-menu">
          {NAV.map(([l, h]) => <a key={l} href={h} onClick={() => setOpen(false)} className="block py-2 text-slate-700">{l}</a>)}
          <Link to={user ? homeFor(user) : "/login"} className="mt-2 block rounded-full bg-[#0A192F] py-2 text-center font-semibold text-white" data-testid="mobile-login-btn">{user ? "My Dashboard" : "Login"}</Link>
          {!user && (
            <div className="mt-2 grid grid-cols-2 gap-2">
              <Link to="/register?type=driver" className="rounded-full border-2 border-[#0A192F] py-2 text-center text-sm font-bold text-[#0A192F]" data-testid="mobile-register-driver-btn">Register as a Driver</Link>
              <Link to="/register?type=customer" className="rounded-full bg-[#FFB703] py-2 text-center text-sm font-bold text-[#0A192F]" data-testid="mobile-register-rider-btn">Register as a Rider</Link>
            </div>
          )}
        </div>
      )}
    </header>
  );
};

export const SiteFooter = ({ cfg }) => (
  <footer className="nf-navy text-slate-300" data-testid="site-footer">
    <div className="nf-road opacity-80" />
    <div className="mx-auto grid max-w-7xl gap-10 px-5 py-14 md:grid-cols-4 lg:px-8">
      <div className="md:col-span-2">
        <Logo light />
        <p className="mt-4 max-w-md text-sm leading-relaxed text-slate-400">
          Nammaafleet is a cab booking marketplace connecting travellers with verified independent driver and vehicle partners across Bengaluru.
        </p>
        <p className="mt-4 text-xs text-slate-500" data-testid="footer-legal">
          {cfg?.legal_name || "[Legal business name — to be configured]"} · {cfg?.address || "[Registered address — to be configured]"}
        </p>
      </div>
      <div>
        <p className="mb-3 text-sm font-semibold text-white">Policies</p>
        {[["Terms & Conditions", "/terms"], ["Privacy Policy", "/privacy"], ["Cancellation & Refund", "/refund-policy"], ["Service Delivery", "/service-policy"]].map(([l, h]) => (
          <Link key={h} to={h} className="block py-1 text-sm hover:text-[#FFB703]" data-testid={`footer-link-${h.slice(1)}`}>{l}</Link>
        ))}
      </div>
      <div>
        <p className="mb-3 text-sm font-semibold text-white">Contact</p>
        <p className="text-sm" data-testid="footer-support-email">{cfg?.support_email || "[Support email — to be configured]"}</p>
        <p className="text-sm" data-testid="footer-support-phone">{cfg?.support_phone || "[Support phone — to be configured]"}</p>
        <Link to="/contact" className="mt-3 inline-block text-sm text-[#FFB703]" data-testid="footer-contact-link">Contact us →</Link>
      </div>
    </div>
    <div className="border-t border-white/10 py-5 text-center text-xs text-slate-500">© 2026 NAMMAAFLEET · ನಮ್ಮ ಫ್ಲೀಟ್</div>
  </footer>
);
